import { Money } from '@dreryk/money-common-api';

import { Text, TextView } from '@dreryk/react-components';
import { getCustomFormattingContext, priceFormatter } from '@dreryk/react-common';

import { translationKeys } from '../translations';

const EMPTY_PLACEHOLDER = '-';

type AdvancePaymentRefundToBeCreatedAmountTextViewProps = Readonly<{
   refundToBeCreatedAmount: Money | null | undefined;
}>;

export const AdvancePaymentRefundToBeCreatedAmountTextView = (
   props: AdvancePaymentRefundToBeCreatedAmountTextViewProps
): JSX.Element => {
   return (
      <TextView testId={'refundToBeCreatedAmount'} label={translationKeys.advancePaymentRefundToBeCreatedAmount}>
         {props.refundToBeCreatedAmount ? (
            <Text testId={'amount'}>
               {priceFormatter(
                  props.refundToBeCreatedAmount.asNumber(),
                  getCustomFormattingContext({
                     options: {
                        currency: 'PLN',
                        stripDecimalZeroes: true,
                     },
                  })
               )}
            </Text>
         ) : (
            EMPTY_PLACEHOLDER
         )}
      </TextView>
   );
};
